/**
 * @generated SignedSource<<30cf8515a913efe279048d6ee9968a29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "style"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "style",
        "variableName": "style"
      }
    ],
    "concreteType": "CreateStyleResponse",
    "kind": "LinkedField",
    "name": "createStyle",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "styleId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateStyleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateStyleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe45ac4c664bdda1e3db46d7c6fa8f3d",
    "id": null,
    "metadata": {},
    "name": "CreateStyleMutation",
    "operationKind": "mutation",
    "text": "mutation CreateStyleMutation(\n  $style: StyleInput!\n) {\n  createStyle(style: $style) {\n    ok\n    error\n    styleId\n  }\n}\n"
  }
};
})();

node.hash = "3c41631733852eafdecb35d579d25066";

export default node;
